export const activateTab = function (el) {
    const tab = el.getAttribute("data-tab");
    if (tab == "practical") {
        el.closest("section").classList.add("practical--active");
    } else {
        el.closest("section").classList.remove("practical--active");
    }
};
